import { PayloadAction } from '@reduxjs/toolkit';

import {
	IOnePageMenu,
	IOnePageMenuState,
} from '../features/OnePageMenu/IOnePageMenu';

export const OnePageMenuReducer = {
	initMenu: (
		state: IOnePageMenuState,
		action: PayloadAction<IOnePageMenuState>
	) => {
		state.menu = action.payload.menu;
	},

	setSelectedMenu: (
		state: IOnePageMenuState,
		action: PayloadAction<IOnePageMenu>
	) => {
		state.selected = action.payload;
	},

	setKey: (state: IOnePageMenuState, action: PayloadAction<string>) => {
		state.key = action.payload;
	},
};
